export function indexEntities(entities, indexName) {
  return entities.reduce(
    (acc, { id, displayName, indexes }) =>
      indexes.includes(indexName) ? [...acc, { id, displayName }] : acc,
    [],
  );
}

// eslint-disable-next-line import/prefer-default-export
export function formatPayloadForMission(entities, missionType, indexName) {
  if (missionType === 'tagging') {
    return (entityId, value) => [{ entityId, value }];
  }

  if (missionType === 'classifier')
    return (entityId, value) => {
      if (value === 'yes') {
        return indexEntities(entities, indexName).map(({ id }) =>
          id === entityId ? { entityId, value: 'yes' } : { entityId: id, value: 'no' },
        );
      }

      return indexEntities(entities, indexName).map(({ id }) => ({ entityId: id, value }));
    };

  if (missionType === 'multilabel') {
    return entityIds => {
      const nos = indexEntities(entities, indexName)
        .filter(({ id }) => !entityIds.includes(id))
        .map(({ id }) => ({ entityId: id, value: 'no' }));

      const yeses = entityIds.map(entityId => ({ entityId, value: 'yes' }));

      return [...nos, ...yeses];
    };
  }

  throw new Error('MissionType must be one of "tagging", "classifier" or "multilabel"');
}
